module.exports = __webpack_public_path__ + "img/icon_violet.d3697b2a.svg";